import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 12v-1.5L10 5.75v2.1l2.2.9v5l-2.2.9v2.1L21 12zm-7-2.62l5.02 1.87L14 13.12V9.38zM6 19.75l3-3H7V4.25H5v12.5H3l3 3z"
}), 'TextRotationDown');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TextRotationDown.js
// module id = 6739
// module chunks = 2